import {
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_DISCOVER_SAMPLE_PORTFOLIOS,
  ROUTE_STOCKS_HOME,
} from '@/constants/routes';
import type { SubNavRoute } from '@/constants/routes';

export type PageType = 'Dividend' | 'Gold' | 'Growth';
export type PageId = '240709' | '215176' | '153';
// A hard coded list of discovery grid ids that'll be presented with the MVP discover page
export const discoveryPageIdList: PageId[] = ['240709', '215176', '153'];

export const discoverRoutes: SubNavRoute[] = [
  {
    to: ROUTE_DISCOVER_INVESTING_IDEAS,
    label: 'Investing Ideas',
  },
  {
    to: ROUTE_STOCKS_HOME,
    label: 'Browse All Stocks',
  },
  {
    to: ROUTE_DISCOVER_SAMPLE_PORTFOLIOS,
    label: 'Sample Portfolios',
  },
];
